import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["data-toast-id", "onClick"];
const _hoisted_2 = { class: "toast-content" };
const _hoisted_3 = { class: "toast-icon" };
const _hoisted_4 = { class: "toast-message" };
const _hoisted_5 = { class: "toast-text" };
const _hoisted_6 = ["onClick"];
import { ref, nextTick } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ToastNotification',
    setup(__props, { expose: __expose }) {
        const toasts = ref([]);
        let toastId = 0;
        const getIconClass = (type) => {
            switch (type) {
                case "success":
                    return "ri-checkbox-circle-fill";
                case "error":
                    return "ri-error-warning-fill";
                case "warning":
                    return "ri-alert-fill";
                case "info":
                    return "ri-information-fill";
                default:
                    return "ri-information-fill";
            }
        };
        const addToast = (message, type = "info", duration = 3000) => {
            const id = toastId++;
            toasts.value.push({ id, message, type, duration });
            nextTick(() => {
                const toastElement = document.querySelector(`[data-toast-id="${id}"]`);
                if (toastElement) {
                    const progressBar = toastElement.querySelector(".toast-progress-bar");
                    animateProgressBar(progressBar, duration);
                }
            });
            setTimeout(() => {
                removeToast(id);
            }, duration);
        };
        const removeToast = (id) => {
            const index = toasts.value.findIndex((toast) => toast.id === id);
            if (index > -1) {
                toasts.value.splice(index, 1);
            }
        };
        // CSP-compliant animation using Web Animations API
        const animateProgressBar = (el, duration) => {
            if (!el)
                return;
            // Use Web Animations API instead of inline styles
            el.animate([{ transform: "scaleX(1)" }, { transform: "scaleX(0)" }], {
                duration,
                easing: "linear",
                fill: "forwards",
            });
        };
        __expose({
            addToast,
            removeToast,
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                _createVNode(_TransitionGroup, {
                    name: "toast",
                    tag: "div",
                    class: "toast-container"
                }, {
                    default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(toasts.value, (toast) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: toast.id,
                                "data-toast-id": toast.id,
                                class: _normalizeClass(['toast-item', `toast-${toast.type}`]),
                                onClick: ($event) => (removeToast(toast.id))
                            }, [
                                _createElementVNode("div", _hoisted_2, [
                                    _createElementVNode("div", _hoisted_3, [
                                        _createElementVNode("i", {
                                            class: _normalizeClass(getIconClass(toast.type))
                                        }, null, 2 /* CLASS */)
                                    ]),
                                    _createElementVNode("div", _hoisted_4, [
                                        _createElementVNode("p", _hoisted_5, _toDisplayString(toast.message), 1 /* TEXT */)
                                    ]),
                                    _createElementVNode("button", {
                                        class: "toast-close",
                                        onClick: _withModifiers(($event) => (removeToast(toast.id)), ["stop"])
                                    }, [...(_cache[0] || (_cache[0] = [
                                            _createElementVNode("i", { class: "ri-close-line" }, null, -1 /* CACHED */)
                                        ]))], 8 /* PROPS */, _hoisted_6)
                                ]),
                                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "toast-progress" }, [
                                    _createElementVNode("div", { class: "toast-progress-bar" })
                                ], -1 /* CACHED */))
                            ], 10 /* CLASS, PROPS */, _hoisted_1));
                        }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _: 1 /* STABLE */
                })
            ]));
        };
    }
});
